export default __webpack_public_path__ + "static/media/Animations_Circle3.2b072395.svg";